<template>
  <div class="product-photo card">
    <div>
      <ul class="el-upload-list el-upload-list--picture-card" v-if="list.length > 0">
        <li tabindex="0" class="el-upload-list__item is-success" v-for="item in list" :key="item.id">
          <img :src="'https://erp.cystrontech.com/' + item.url + '?x-oss-process=style/thumb'" alt="" class="el-upload-list__item-thumbnail"/>
          <a class="el-upload-list__item-name" @click="handleEditName(item)">
            <i class="el-icon-edit"></i>{{ item.name }}
          </a>
          <span style="display:block;line-height:18px;font-size:12px;text-align:right;padding-right:4px;">
            {{ item.oper_name }}&nbsp;{{ item.upload_time.substr(5, 11) }}
          </span>
          <span class="el-upload-list__item-actions">
            <span class="el-upload-list__item-preview" @click="handlePreview(item)">
              <i class="el-icon-zoom-in"></i>
            </span>
            <span class="el-upload-list__item-delete" @click="handleRemove(item)">
              <i class="el-icon-delete"></i>
            </span>
          </span>
        </li>
      </ul>
      <el-upload
        class="el-upload el-upload--picture-card"
        :action="baseUrl + 'api/upload'"
        :headers="uploadHeaders"
        :show-file-list="false"
        :on-success="handleScucess">
          <i class="el-icon-plus"></i>
      </el-upload>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      list: [],
      baseUrl: process.env.VUE_APP_API,
      uploadHeaders: {
        token: window.sessionStorage.getItem('token'),
        'Access-Control-Allow-Origin': '*'
      }
    }
  },
  mounted () {
    this.fetchList()
  },
  methods: {
    fetchList () {
      this.$http.get('/dbapi/product_photo_list?product_id=' + this.$route.params.id).then(data => {
        this.list = data.list
      })
    },
    handleScucess (res, file) {
      if (res.success) {
        this.$message({ type: 'success', message: res.message })
        this.$http.post('/dbapi/product_photo_insert', {
          product_id: this.$route.params.id,
          name: res.name,
          url: res.url
        }).then(() => {
          this.fetchList()
        })
      } else {
        this.$message({ type: 'error', message: res.message })
      }
    },
    handleRemove (item) {
      this.$confirm('确定要删除吗?', 'Confirm', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/product_photo_del', { id: item.id }).then(() => {
          this.fetchList()
        })
      })
    },
    handlePreview (item) {
      this.$open('https://erp.cystrontech.com/' + item.url + '?x-oss-process=style/full')
    },
    handleEditName (item) {
      this.$prompt('修改照片标题', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: item.name
      }).then(({ value }) => {
        item.name = value
        this.$http.post('/dbapi/product_photo_edit', { id: item.id, name: value })
      })
    }
  }
}
</script>


<style lang="scss">
.product-photo {
  .el-upload-list--picture-card {
    .el-upload-list__item {
      height: 200px;
    }
    .el-upload-list__item-name {
      display: block;
      margin-right: 0;
      line-height: 18px;
      [class^=el-icon] {
        margin-right: 2px;
      }
    }
    .el-upload-list__item-thumbnail {
      height: 148px;
    }
    .el-upload-list__item-actions {
      height: 148px;
    }
  }
}
</style>

      